import { render, staticRenderFns } from "./LabForm.vue?vue&type=template&id=ab364140&scoped=true"
import script from "./LabForm.vue?vue&type=script&lang=js"
export * from "./LabForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab364140",
  null
  
)

export default component.exports